module.exports = __webpack_public_path__ + "img/SjoLand.d6e17660.jpg";